import { Component, Input, OnInit } from '@angular/core';
import { AppNavV2Service } from 'src/app/services/app-nav-v2/app-nav-v2.service';
import { SavvasLinkGeneratorService } from 'src/app/services/link-generators-v2/savvas-link-generator.service';
import { StandardSetSettings, StandardSetModel, StandardSetType } from '../../settings/standard-set-settings.constants';
import { ProductAppCodes } from 'src/app/services/product-info/product-info.service';
import { ScopeSequenceStandard } from 'src/app/services/graphql/scope-sequence-standards-response';

@Component({
  selector: 'app-instruction',
  templateUrl: './instruction.component.html',
  styleUrls: ['./instruction.component.scss'],
})
export class InstructionComponent implements OnInit {
  @Input() public standardSetType: string = '';
  @Input() public selectedStandard!: ScopeSequenceStandard;
  @Input() public skillIds: string[] = [];

  public selectedStandardSet: StandardSetModel = StandardSetSettings[0];

  constructor(
    private appNavV2Service: AppNavV2Service,
    public savvasLinkGeneratorService: SavvasLinkGeneratorService
  ) { }

  public ngOnInit(): void {
    this.selectedStandardSet = StandardSetSettings.find(x => x.standardSetType.toLowerCase() === this.standardSetType.toLowerCase())!;
  }

  get title(): string {
    if (this.standardSetType === StandardSetType.Envision) {
      const grade = this.selectedStandard.collectionLongName
      return `${this.selectedStandardSet?.instructionEnVisionRealizeTitle}, ${grade}`
    }

    return this.selectedStandardSet?.instructionEnVisionRealizeTitle || '';
  }

  get buttonText(): string {
    if (this.standardSetType === StandardSetType.Envision) {
      return 'Explore enVision Resources';
    }

    return 'Find Resources for ' + this.selectedStandard.standardName;
  }

  public async navigateToSavvas(): Promise<void> {
    if (this.standardSetType  === StandardSetType.Envision) {
      const otherAvailableApps = await this.appNavV2Service.getOtherAvailableApps();
      const savvasApp = otherAvailableApps.find(app => app.appCode === ProductAppCodes.Savvas);
      if (!savvasApp) {
        return;
      }
      return this.savvasLinkGeneratorService.appLaunch();
    }

    return this.savvasLinkGeneratorService.appLaunch(this.skillIds);
  }
}
